function normalizeNavPath(path: string): string {
  return path.replace(/\/$/, '') || '/';
}

export function isNavLinkActive(pathname: string, href?: string, exact = false): boolean {
  if (!href) return false;

  const path = normalizeNavPath(pathname);
  const link = normalizeNavPath(href);

  if (link === '/') return path === '/';
  if (exact) return path === link;

  return path === link || path.startsWith(`${link}/`);
}
